import EventBus from './event-bus';

const FlashMessages = {
    add (message, title = '', type = 'info', sticky = false, queue = null) {
        const m = {
            title,
            message,
            type,
            sticky,
            queue,
        };

        EventBus.$emit('message', m);
    },
    notice (message, title = '', sticky = false, queue = null) {
        this.add(message, title, 'notice', sticky, queue);
    },
    info (message, title = '', sticky = false, queue = null) {
        this.add(message, title, 'info', sticky, queue);
    },
    success (message, title = '', sticky = false, queue = null) {
        this.add(message, title, 'success', sticky, queue);
    },
    warning (message, title = '', sticky = false, queue = null) {
        this.add(message, title, 'warning', sticky, queue);
    },
    danger (message, title = '', sticky = false, queue = null) {
        this.add(message, title, 'danger', sticky, queue);
    },
    reset () {
        EventBus.$emit('messageReset');
    },
    onAdd (callback) {
        EventBus.$on('message', callback);
    },
    onReset (callback) {
        EventBus.$on('messageReset', callback);
    },
};

export default FlashMessages;
